import { request } from "apis/base";
import {
  ExportJobDetailResponseType,
  ExportJobResponseType,
  ExportPreGeneratedParams,
  ExportPreGeneratedResponse,
  ExportRequestParams,
} from "constants/types/export";
import { CommonSuccessResponse } from "constants/types/common";
import { AxiosResponse } from "axios";

export const exportApi = {
  getPreGenerated: (
    params: ExportPreGeneratedParams,
  ): Promise<{ data: CommonSuccessResponse<ExportPreGeneratedResponse> }> => {
    return request({ url: "/export/pre-generated", method: "GET", params });
  },

  requestExport: (data: ExportRequestParams): Promise<AxiosResponse<Blob>> => {
    return request({
      url: "/export/request",
      method: "POST",
      data,
      responseType: "blob",
    });
  },

  getJobs: (): Promise<{ data: CommonSuccessResponse<ExportJobResponseType[]> }> => {
    return request({ url: "/export/jobs", method: "GET" });
  },

  getJobById: (id: string): Promise<{ data: CommonSuccessResponse<ExportJobDetailResponseType> }> => {
    return request({ url: `/export/jobs/${id}`, method: "GET" });
  },
};
